export const LIST_TRANSACTION_DATA_ADMISSION_REQUEST =
  'LIST_TRANSACTION_DATA_ADMISSION_REQUEST'
export const LIST_TRANSACTION_DATA_ADMISSION_SUCCESS =
  'LIST_TRANSACTION_DATA_ADMISSION_SUCCESS'
export const LIST_TRANSACTION_DATA_ADMISSION_FAIL =
  'LIST_TRANSACTION_DATA_ADMISSION_FAIL'

export const LIST_TRANSACTION_DATA_CASHIER_REQUEST =
  'LIST_TRANSACTION_DATA_CASHIER_REQUEST'
export const LIST_TRANSACTION_DATA_CASHIER_SUCCESS =
  'LIST_TRANSACTION_DATA_CASHIER_SUCCESS'
export const LIST_TRANSACTION_DATA_CASHIER_FAIL =
  'LIST_TRANSACTION_DATA_CASHIER_FAIL'

export const LIST_TRANSACTION_DATA_PHOTO_PATIENT_REQUEST = 'LIST_TRANSACTION_DATA_PHOTO_PATIENT_REQUEST'
export const LIST_TRANSACTION_DATA_PHOTO_PATIENT_SUCCESS = 'LIST_TRANSACTION_DATA_PHOTO_PATIENT_SUCCESS'
export const LIST_TRANSACTION_DATA_PHOTO_PATIENT_FAIL = 'LIST_TRANSACTION_DATA_PHOTO_PATIENT_FAIL'

export const LIST_TRANSACTION_DATA_REQUEST = 'LIST_TRANSACTION_DATA_REQUEST'
export const LIST_TRANSACTION_DATA_SUCCESS = 'LIST_TRANSACTION_DATA_SUCCESS'
export const LIST_TRANSACTION_DATA_FAIL = 'LIST_TRANSACTION_DATA_FAIL'

export const RE_SYNC_TRANSACTION_DATA_FAILED_REQUEST = 'RE_SYNC_TRANSACTION_DATA_FAILED_REQUEST'
export const RE_SYNC_TRANSACTION_DATA_FAILED_SUCCESS = 'RE_SYNC_TRANSACTION_DATA_FAILED_SUCCESS'
export const RE_SYNC_TRANSACTION_DATA_FAILED_FAIL = 'RE_SYNC_TRANSACTION_DATA_FAILED_FAIL'

export const SYNC_DATA_TRANSACTION_DATA_REQUEST = 'SYNC_DATA_TRANSACTION_DATA_REQUEST'
export const SYNC_DATA_TRANSACTION_DATA_SUCCESS = 'SYNC_DATA_TRANSACTION_DATA_SUCCESS'
export const SYNC_DATA_TRANSACTION_DATA_FAIL = 'SYNC_DATA_TRANSACTION_DATA_FAIL'